module.exports = __webpack_public_path__ + "static/media/onboardingHandover.c7413438.png";